<template>
  <div style="background: #f8fafc; min-height: 100vh; font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;">
    <ServicesServiceHero
      title="AWS DevOps Engineering"
      description="Streamline your deployment pipeline with automated, scalable, and secure DevOps practices"
      icon="🔄"
      gradient="aws-devops"
    />

    <!-- Main Content -->
    <div class="container" style="max-width: 1000px;">
      <div class="row">
        <div class="col-md-12">
          <div class="devops-main-card">
            <h2 style="color: #1a202c; font-weight: 700; margin-bottom: 24px; font-size: 2.2rem;">Accelerate Your Development Lifecycle 🚀</h2>
            <p style="color: #4a5568; line-height: 1.7; font-size: 1.1rem; margin-bottom: 40px;">DevOps isn't just about tools—it's about transforming how your teams collaborate and deliver value. Our AWS DevOps services help you build a culture of continuous improvement with automated workflows, infrastructure as code, and robust monitoring systems that enable rapid, reliable delivery.</p>
            
            <h3 style="color: #1a202c; font-weight: 600; margin-bottom: 30px; font-size: 1.8rem;">The DevOps Advantage</h3>
            <div class="row">
              <div class="col-md-6 mb-4">
                <div style="background: #f7fafc; padding: 24px; border-radius: 12px; border-left: 4px solid var(--aws-devops-start); height: 100%;">
                  <h4 style="color: #1a202c; font-weight: 600; margin-bottom: 12px;">⚡ Speed to Market</h4>
                  <p style="color: #4a5568; margin: 0; line-height: 1.6;">Reduce deployment time from weeks to minutes with automated pipelines</p>
                </div>
              </div>
              <div class="col-md-6 mb-4">
                <div style="background: #f7fafc; padding: 24px; border-radius: 12px; border-left: 4px solid var(--aws-devops-start); height: 100%;">
                  <h4 style="color: #1a202c; font-weight: 600; margin-bottom: 12px;">🛠️ Reliability</h4>
                  <p style="color: #4a5568; margin: 0; line-height: 1.6;">Eliminate human error with consistent, repeatable deployment processes</p>
                </div>
              </div>
              <div class="col-md-6 mb-4">
                <div style="background: #f7fafc; padding: 24px; border-radius: 12px; border-left: 4px solid var(--aws-devops-start); height: 100%;">
                  <h4 style="color: #1a202c; font-weight: 600; margin-bottom: 12px;">📊 Visibility</h4>
                  <p style="color: #4a5568; margin: 0; line-height: 1.6;">Gain real-time insights into application performance and infrastructure health</p>
                </div>
              </div>
              <div class="col-md-6 mb-4">
                <div style="background: #f7fafc; padding: 24px; border-radius: 12px; border-left: 4px solid var(--aws-devops-start); height: 100%;">
                  <h4 style="color: #1a202c; font-weight: 600; margin-bottom: 12px;">💰 Cost Efficiency</h4>
                  <p style="color: #4a5568; margin: 0; line-height: 1.6;">Optimize resource utilization and automate scaling to match demand</p>
                </div>
              </div>
            </div>

            <h3 style="color: #1a202c; font-weight: 600; margin-bottom: 30px; margin-top: 50px; font-size: 1.8rem;">Our DevOps Services</h3>
            
            <div class="row">
              <div class="col-md-6 mb-4">
                <div style="background: linear-gradient(135deg, var(--aws-devops-start) 0%, var(--aws-devops-end) 100%); color: white; padding: 32px; border-radius: 16px; height: 100%;">
                  <h4 style="font-weight: 700; margin-bottom: 16px; font-size: 1.3rem;">🔄 CI/CD Pipeline Implementation</h4>
                  <ul style="margin: 0; padding-left: 20px; line-height: 1.8;">
                    <li>AWS CodePipeline & CodeBuild</li>
                    <li>GitHub Actions Integration</li>
                    <li>Jenkins Configuration</li>
                    <li>Automated Testing</li>
                  </ul>
                </div>
              </div>
              <div class="col-md-6 mb-4">
                <div style="background: linear-gradient(135deg, var(--aws-devops-start) 0%, var(--aws-devops-end) 100%); color: white; padding: 32px; border-radius: 16px; height: 100%;">
                  <h4 style="font-weight: 700; margin-bottom: 16px; font-size: 1.3rem;">📝 Infrastructure as Code</h4>
                  <ul style="margin: 0; padding-left: 20px; line-height: 1.8;">
                    <li>AWS CloudFormation</li>
                    <li>Terraform Automation</li>
                    <li>CDK Development</li>
                    <li>Version-Controlled Infrastructure</li>
                  </ul>
                </div>
              </div>
              <div class="col-md-6 mb-4">
                <div style="background: linear-gradient(135deg, var(--aws-devops-start) 0%, var(--aws-devops-end) 100%); color: white; padding: 32px; border-radius: 16px; height: 100%;">
                  <h4 style="font-weight: 700; margin-bottom: 16px; font-size: 1.3rem;">🔍 Monitoring & Observability</h4>
                  <ul style="margin: 0; padding-left: 20px; line-height: 1.8;">
                    <li>CloudWatch Dashboards</li>
                    <li>Centralized Logging</li>
                    <li>Automated Alerting</li>
                    <li>Performance Metrics</li>
                  </ul>
                </div>
              </div>
              <div class="col-md-6 mb-4">
                <div style="background: linear-gradient(135deg, var(--aws-devops-start) 0%, var(--aws-devops-end) 100%); color: white; padding: 32px; border-radius: 16px; height: 100%;">
                  <h4 style="font-weight: 700; margin-bottom: 16px; font-size: 1.3rem;">🛡️ Security Automation</h4>
                  <ul style="margin: 0; padding-left: 20px; line-height: 1.8;">
                    <li>Compliance as Code</li>
                    <li>Automated Security Scanning</li>
                    <li>Secrets Management</li>
                    <li>Least Privilege Access</li>
                  </ul>
                </div>
              </div>
            </div>

            <h3 style="color: #1a202c; font-weight: 600; margin-bottom: 30px; margin-top: 50px; font-size: 1.8rem;">Our DevOps Approach</h3>
            
            <div style="background: #f7fafc; padding: 40px; border-radius: 16px; margin-bottom: 40px;">
              <div class="row">
                <div class="col-md-4 mb-4 mb-md-0">
                  <div style="text-align: center;">
                    <div style="width: 80px; height: 80px; background: linear-gradient(135deg, var(--aws-devops-start), var(--aws-devops-end)); color: white; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px auto; font-size: 32px;">1</div>
                    <h5 style="color: #1a202c; font-weight: 600; margin-bottom: 12px;">Assess</h5>
                    <p style="color: #4a5568; margin: 0; font-size: 0.95rem;">Evaluate your current workflows and identify bottlenecks</p>
                  </div>
                </div>
                <div class="col-md-4 mb-4 mb-md-0">
                  <div style="text-align: center;">
                    <div style="width: 80px; height: 80px; background: linear-gradient(135deg, var(--aws-devops-start), var(--aws-devops-end)); color: white; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px auto; font-size: 32px;">2</div>
                    <h5 style="color: #1a202c; font-weight: 600; margin-bottom: 12px;">Implement</h5>
                    <p style="color: #4a5568; margin: 0; font-size: 0.95rem;">Build and integrate automated DevOps toolchains</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div style="text-align: center;">
                    <div style="width: 80px; height: 80px; background: linear-gradient(135deg, var(--aws-devops-start), var(--aws-devops-end)); color: white; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px auto; font-size: 32px;">3</div>
                    <h5 style="color: #1a202c; font-weight: 600; margin-bottom: 12px;">Optimize</h5>
                    <p style="color: #4a5568; margin: 0; font-size: 0.95rem;">Continuously improve processes and performance</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Pricing Section -->
            <div style="background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%); padding: 40px; border-radius: 16px; margin-top: 50px; border-left: 4px solid #3b82f6; text-align: center;">
              <h3 style="color: #1a202c; font-weight: 700; margin-bottom: 16px; font-size: 1.8rem;">Transparent Pricing</h3>
              <p style="color: #4a5568; font-size: 1.1rem; line-height: 1.7; margin-bottom: 24px; max-width: 700px; margin-left: auto; margin-right: auto;">
                Standard rate of <strong style="color: #1a202c; font-size: 1.2rem;">$225/hour</strong> for consulting and implementation. Volume discounts and retainer packages available.
              </p>
              <NuxtLink to="/services/pricing" style="display: inline-block; background: #3b82f6; color: white; padding: 14px 32px; border-radius: 8px; font-weight: 600; text-decoration: none; font-size: 1.05rem; transition: background 0.2s;">
                View Full Pricing Details
              </NuxtLink>
            </div>

            <div style="background: linear-gradient(135deg, var(--aws-devops-start) 0%, var(--aws-devops-end) 100%); color: white; padding: 40px; border-radius: 16px; margin-top: 50px; text-align: center;">
              <h3 style="font-weight: 700; margin-bottom: 20px; font-size: 1.8rem;">Ready to Transform Your Development Process?</h3>
              <p style="font-size: 1.1rem; opacity: 0.95; line-height: 1.6; margin-bottom: 30px;">Whether you're just starting your DevOps journey or looking to optimize your existing processes, we can help you build a more efficient, reliable delivery pipeline.</p>
              <div style="display: flex; gap: 20px; justify-content: center; flex-wrap: wrap;">
                <div style="background: rgba(255,255,255,0.2); padding: 20px; border-radius: 12px; backdrop-filter: blur(10px); border: 1px solid rgba(255,255,255,0.3); flex: 1; min-width: 200px; max-width: 250px;">
                  <h4 style="font-weight: 600; margin-bottom: 12px;">🏗️ Build</h4>
                  <p style="margin: 0; font-size: 0.95rem; opacity: 0.9;">Create new DevOps pipelines</p>
                </div>
                <div style="background: rgba(255,255,255,0.2); padding: 20px; border-radius: 12px; backdrop-filter: blur(10px); border: 1px solid rgba(255,255,255,0.3); flex: 1; min-width: 200px; max-width: 250px;">
                  <h4 style="font-weight: 600; margin-bottom: 12px;">🔧 Improve</h4>
                  <p style="margin: 0; font-size: 0.95rem; opacity: 0.9;">Optimize existing workflows</p>
                </div>
                <div style="background: rgba(255,255,255,0.2); padding: 20px; border-radius: 12px; backdrop-filter: blur(10px); border: 1px solid rgba(255,255,255,0.3); flex: 1; min-width: 200px; max-width: 250px;">
                  <h4 style="font-weight: 600; margin-bottom: 12px;">🎓 Train</h4>
                  <p style="margin: 0; font-size: 0.95rem; opacity: 0.9;">Upskill your development team</p>
                </div>
              </div>
              <p style="margin-top: 30px; margin-bottom: 0; font-style: italic; opacity: 0.9;">Automate, integrate, and accelerate your path to success.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
useHead({
  title: 'AWS DevOps Engineering | Geek Cafe',
  meta: [
    { name: 'description', content: 'Streamline your deployment pipeline with automated, scalable, and secure DevOps practices. Expert AWS DevOps engineering services.' }
  ]
})
</script>

<style scoped src="@/assets/css/service-detail-card.css"></style>
